export default __webpack_public_path__ + "static/media/wrong.154b7be9.svg";